/**
 * 가상번호 관리 (/adm/virtual-number) — 가상번호 풀·이력·회원 매칭/해제·통신사(다우) 대조
 * ($j.Pages.Admin.VirtualNumber / body data-page-name="VirtualNumber")
 */
export default class VirtualNumber {
    initialize() { initialize(); }
}

let poolTable = null;

const DT_LANG = {
    emptyTable: "데이터가 없습니다.",
    lengthMenu: "_MENU_ 개씩 보기",
    info: "_TOTAL_건 중 _START_–_END_",
    infoEmpty: "0건",
    search: "검색:",
    paginate: {first: "처음", last: "끝", next: "다음", previous: "이전"},
    zeroRecords: "검색 결과가 없습니다.",
};

function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
}

function initialize() {
    // 매칭 패널은 .card(flex) — 처음 숨김은 sass(.vn-pre-hidden)가 하고, 여기서 jQuery hide() 로 넘겨
    // slideDown 이 flex 로 되살아나게 한다(같은 틱이라 깜빡이지 않는다)
    $('#cm-match-panel').removeClass('vn-pre-hidden').hide();
    $('#cm-pool-reload').on('click', () => poolTable && poolTable.ajax.reload(null, false));

    // 가상번호 클릭 → 이력 모달 (JBModal)
    $('#cm-pool-table').on('click', '.cm-vn-history', onClickHistory);

    // 통신사 대조
    $('#cm-reconcile').on('click', onReconcile);
    $('#cm-recon-close').on('click', () => $('#cm-recon-modal').hide());
    $('#cm-recon-modal').on('click', function (e) { if (e.target === this) $(this).hide(); });
    $('#cm-recon-body').on('click', '.cm-recon-act', onReconAct);
    $('#cm-recon-body').on('click', '#cm-recon-add-all', onReconAddAll);

    // 매칭/해제 버튼 (위임)
    $('#cm-pool-table').on('click', '.cm-match', onClickMatch);
    $('#cm-pool-table').on('click', '.cm-release', onClickRelease);

    // 매칭 패널
    $('#cm-match-close').on('click', () => $('#cm-match-panel').slideUp(120));
    $('#cm-match-clear').on('click', () => $('#cm-match-mem').val('').trigger('input').focus());
    $('#cm-match-submit').on('click', onSubmitMatch);
    bindMemberAc();   // 회원 자동완성

    initPoolTable();
}

// ── DataTables ───────────────────────────────────────────────
function initPoolTable() {
    poolTable = new DataTable('#cm-pool-table', {
        ajax: {
            url: '/adm/ajax/virtual-number/pool', type: 'post',
            dataSrc: function (json) {
                const rows = json.data || [];
                const busy = rows.filter(r => String(r.status) === '1').length;
                $('#cm-pool-summary').text(`총 ${rows.length} · 사용중 ${busy} · 미사용 ${rows.length - busy}`);
                return rows;
            },
        },
        columns: [
            {data: null, title: '#', orderable: false, render: rowSeq},
            {data: 'virtual_number', title: '가상번호', render: vnHistoryLink},
            {data: 'real_number', title: '연결 실번호', render: d => d ? esc($j.Common.Util.phoneNumber(d)) : '<span class="text-muted">-</span>'},
            {data: null, title: '회원', render: memberLink},
            {data: 'status', title: '상태', render: poolStatusBadge},
            {data: 'used_at', title: '사용 시작', render: d => d ? $j.Common.Util.formatDateTime(d) : '<span class="text-muted">-</span>'},
            {data: null, title: '동작', orderable: false, render: poolActionBtn},
        ],
        columnDefs: [{targets: '_all', className: 'text-center'}],
        headerCallback: (thead) => $(thead).find('th').css('text-align', 'center'),
        order: [],
        pageLength: 25,
        language: DT_LANG,
    });
}

// 표시 순서 기준 일련번호 (DB num 아님). 풀은 클라이언트사이드라 meta.row 절대인덱스 그대로 +1.
function rowSeq(data, type, row, meta) {
    return meta.row + 1;
}

// 가상번호 셀 — 대시 포맷 + 클릭 시 이력 모달
function vnHistoryLink(data) {
    const vn = String(data == null ? '' : data);
    return `<a href="javascript:void(0)" class="cm-vn-history" data-vn="${esc(vn)}">${esc($j.Common.Util.phoneNumber(vn) || vn)}</a>`;
}

// ── 가상번호 이력 모달 (JBModal) ───────────────────────────────
function onClickHistory() {
    const vn = String($(this).data('vn'));
    const title = `가상번호 이력 · ${$j.Common.Util.phoneNumber(vn) || vn}`;
    const loading = '<div class="text-center text-muted py-4"><i class="fa fa-spinner fa-spin"></i> 불러오는 중...</div>';
    $j.Ui.JBModal.html('cm-hist', loading, title, {width: '620px'});

    $.post('/adm/ajax/virtual-number/history', {virtual_number: vn}, function (res) {
        $('#cm-hist .jb-modal-body').html(renderHistory(res.data || []));
    }, 'json').fail(() => $('#cm-hist .jb-modal-body').html('<div class="alert alert-danger mb-0">서버 오류</div>'));
}

function renderHistory(rows) {
    if (!rows.length) return '<div class="alert alert-secondary mb-0">이력이 없습니다.</div>';

    let html = '<table class="table table-bordered table-sm mb-0 vn-s15">'
        + '<thead><tr class="text-center"><th class="vn-s16">#</th><th>연결 실번호</th><th class="vn-s17">동작</th><th class="vn-s18">기록 시각</th></tr></thead><tbody>';
    rows.forEach((r, i) => {
        const rn = r.real_number ? esc($j.Common.Util.phoneNumber(r.real_number)) : '<span class="text-muted">-</span>';
        html += `<tr class="text-center"><td>${i + 1}</td><td>${rn}</td>`
            + `<td>${logStatusBadge(r.status)}</td><td>${r.created_at ? $j.Common.Util.formatDateTime(r.created_at) : ''}</td></tr>`;
    });
    html += '</tbody></table>';
    return html;
}

// 연결 회원 — 이름 클릭 시 악덕알리미 회원 모바일 팝업(대리로그인 프록시) · #번호 = 회원 팝오버
function memberLink(data, type, row) {
    if (!row.mb_no) return '<span class="text-muted">-</span>';
    return `<a href="javascript:$j.F.Admin.Util.devilMobile(${row.mb_no})">${esc(row.mem_name || '회원')}</a>`
        + `<small class="text-muted">#${$j.F.Admin.Member.Pop.cellNo(row.mb_no)}</small>`;
}

function poolStatusBadge(d) {
    return String(d) === '1'
        ? '<span class="badge bg-success">사용중</span>'
        : '<span class="badge bg-secondary">미사용</span>';
}
function logStatusBadge(d) {
    return String(d) === '1'
        ? '<span class="badge bg-primary">설정</span>'
        : '<span class="badge bg-secondary">해제</span>';
}
function poolActionBtn(data, type, row) {
    const vn = esc(row.virtual_number);
    return String(row.status) === '1'
        ? `<button class="btn btn-sm btn-outline-danger cm-release" type="button" data-vn="${vn}"><i class="fa fa-unlink"></i> 해제</button>`
        : `<button class="btn btn-sm btn-outline-primary cm-match" type="button" data-vn="${vn}"><i class="fa fa-link"></i> 매칭</button>`;
}

// ── 통신사 대조 ───────────────────────────────────────────────
const RECON_LABEL = {
    carrier_busy_db_free: '통신사 사용중 ↔ DB 미사용 (좀비)',
    db_busy_carrier_free: 'DB 사용중 ↔ 통신사 미사용',
    rn_mismatch:          '실번호 불일치',
    carrier_only:         '통신사에만 있음 (풀 미등록)',
    db_only:              'DB에만 있음 (통신사에 없음)',
};

function onReconcile() {
    const $btn = $('#cm-reconcile').prop('disabled', true).html('<i class="fa fa-spinner fa-spin"></i> 대조 중...');
    $.post('/adm/ajax/virtual-number/reconcile', {}, function (res) {
        if (!res.result) { $j.Ui.Dialog.open({tone: 'danger', title: res.message || '대조 실패'}); return; }
        renderRecon(res);
        $('#cm-recon-modal').css('display', 'block');
    }, 'json').fail(() => $j.Ui.Dialog.open({tone: 'danger', title: '서버 오류'}))
      .always(() => $btn.prop('disabled', false).html('<i class="fa fa-scale-balanced"></i> 통신사 대조'));
}

function renderRecon(res) {
    $('#cm-recon-summary').text(`통신사 ${res.total_carrier} · DB ${res.total_local} · 불일치 ${res.mismatch_count}`);
    const $body = $('#cm-recon-body').empty();
    if (!res.mismatch_count) {
        $body.html('<div class="alert alert-success mb-0">✓ 모든 가상번호 상태가 통신사와 일치합니다.</div>');
        return;
    }
    const groups = {};
    (res.mismatches || []).forEach(m => { (groups[m.type] = groups[m.type] || []).push(m); });
    Object.keys(RECON_LABEL).forEach(type => {
        const rows = groups[type];
        if (!rows || !rows.length) return;
        const addAll = type === 'carrier_only'
            ? ` <button class="btn btn-sm btn-primary vn-s9" id="cm-recon-add-all" type="button"><i class="fa fa-plus"></i> 전체 추가</button>`
            : '';
        let html = `<div class="mb-3"><div class="mb-1"><b>${RECON_LABEL[type]}</b> <span class="badge bg-danger">${rows.length}</span>${addAll}</div>`
            + '<table class="table table-bordered table-sm mb-0 vn-s19"><thead><tr class="text-center">'
            + '<th>가상번호</th><th>DB 상태</th><th>통신사 상태</th><th class="vn-s20">조치</th></tr></thead><tbody>';
        rows.forEach(m => {
            html += `<tr class="text-center"><td>${esc(m.vn)}</td><td>${esc(m.db)}</td><td>${esc(m.carrier)}</td>`
                + `<td>${reconBtns(m)}</td></tr>`;
        });
        html += '</tbody></table></div>';
        $body.append(html);
    });
}

// 불일치 유형별 조치 버튼
function reconBtns(m) {
    const vn = esc(m.vn);
    const release = `<button class="btn btn-sm btn-outline-danger cm-recon-act" type="button" data-act="release" data-vn="${vn}"><i class="fa fa-unlink"></i> 해제</button>`;
    const remove  = `<button class="btn btn-sm btn-outline-secondary cm-recon-act" type="button" data-act="remove" data-vn="${vn}"><i class="fa fa-trash"></i> 삭제</button>`;
    const add     = `<button class="btn btn-sm btn-outline-primary cm-recon-act" type="button" data-act="sync" data-vn="${vn}" data-busy="${m.c_busy ? 1 : 0}" data-rn="${esc(m.c_rn || '')}"><i class="fa fa-plus"></i> 추가</button>`;
    switch (m.type) {
        case 'carrier_only': return add;      // 통신사에만 있음 → 풀에 추가
        case 'db_only':      return remove;   // DB에만 있음 → 풀에서 삭제
        default:             return release;  // 좀비 / 실번호불일치 / DB사용중·통신사미사용 → 해제(통신사 cancel + DB free)
    }
}

const RECON_ACT_LABEL = {release: '해제', sync: '풀에 추가', remove: '풀에서 삭제'};

// 대조 조치 실행 → 통신사 cancel / DB반영 / 삭제 후 재대조 & 풀 갱신
function onReconAct() {
    const $btn = $(this);
    const act = String($btn.data('act'));
    const vn = String($btn.data('vn'));
    const orig = $btn.html();

    $j.Ui.Dialog.open({
        tone: 'warn', title: RECON_ACT_LABEL[act] || '조치',
        html: `가상번호 <b>${esc(vn)}</b><br>${RECON_ACT_LABEL[act] || ''} 처리할까요?`,
        confirm: '확인', cancel: '취소',
    }).then(function (ok) {
        if (!ok) return;
        const data = {virtual_number: vn, action: act};
        if (act === 'sync') { data.c_busy = $btn.data('busy') ? 1 : 0; data.c_rn = String($btn.data('rn') || ''); }
        $btn.prop('disabled', true).html('<i class="fa fa-spinner fa-spin"></i>');
        $.post('/adm/ajax/virtual-number/reconcile-fix', data, function (res) {
            if (res.result) {
                onReconcile();                                       // 모달 다시 대조(갱신)
                if (poolTable) poolTable.ajax.reload(null, false);   // 풀 테이블 갱신
            } else {
                $j.Ui.Dialog.open({tone: 'danger', title: res.message || '조치 실패'});
                $btn.prop('disabled', false).html(orig);
            }
        }, 'json').fail(() => {
            $j.Ui.Dialog.open({tone: 'danger', title: '서버 오류'});
            $btn.prop('disabled', false).html(orig);
        });
    });
}

// 통신사에만 있는 번호 전체를 풀에 추가 (서버가 통신사를 다시 조회해 그 상태대로 넣는다)
function onReconAddAll() {
    const $btn = $(this);
    const orig = $btn.html();
    $j.Ui.Dialog.open({
        tone: 'warn', title: '전체 추가',
        html: '통신사에만 있는 가상번호를 <b>모두</b> 풀에 추가할까요?',
        confirm: '확인', cancel: '취소',
    }).then(function (ok) {
        if (!ok) return;
        $btn.prop('disabled', true).html('<i class="fa fa-spinner fa-spin"></i> 추가 중...');
        $.post('/adm/ajax/virtual-number/reconcile-add-all', {}, function (res) {
            $j.Ui.Dialog.open({tone: res.result ? 'success' : 'danger', title: res.result ? '추가 완료' : '일부 실패', html: esc(res.message || '').replace(/\n/g, '<br>')});
            onReconcile();                                       // 모달 다시 대조(갱신)
            if (poolTable) poolTable.ajax.reload(null, false);   // 풀 테이블 갱신
        }, 'json').fail(() => {
            $j.Ui.Dialog.open({tone: 'danger', title: '서버 오류'});
            $btn.prop('disabled', false).html(orig);
        });
    });
}

// ── 매칭 ─────────────────────────────────────────────────────
function onClickMatch() {
    const vn = String($(this).data('vn'));
    $('#cm-match-vn').val(vn);
    $('#cm-match-mem').val('').data('pick', null);
    $('#cm-match-clear').hide();
    $('#cm-match-panel').slideDown(120);
    setTimeout(() => $('#cm-match-mem').focus(), 130);
}

function onSubmitMatch() {
    const vn = String($('#cm-match-vn').val()).trim();
    const pick = $('#cm-match-mem').data('pick') || null;

    if (!vn) return;
    if (!pick || !pick.mb_no) {
        $j.Ui.Dialog.open({tone: 'warn', title: '회원이 아닙니다', desc: '회원 검색에서 회원을 선택해주세요.'});
        return;
    }

    const $btn = $('#cm-match-submit').prop('disabled', true).html('<i class="fa fa-spinner fa-spin"></i> 매칭 중...');
    $.post('/adm/ajax/virtual-number/assign', {virtual_number: vn, mb_no: pick.mb_no}, function (res) {
        // 성공은 스스로 사라지던 알림이라 토스트, 실패는 눌러서 닫는 다이얼로그
        if (res.result) $j.Ui.Toast.show(res.message || '매칭되었습니다.', {type: 'success'});
        else $j.Ui.Dialog.open({tone: 'danger', title: res.message || '매칭 실패'});
        if (res.result) {
            $('#cm-match-panel').slideUp(120);
            poolTable.ajax.reload(null, false);
        }
    }, 'json').fail(() => $j.Ui.Dialog.open({tone: 'danger', title: '서버 오류'}))
      .always(() => $btn.prop('disabled', false).html('<i class="fa fa-link"></i> 매칭'));
}

// 회원 자동완성 — /adm/ajax/devil/call/member-search (TestCall 과 동일 소스)
function bindMemberAc() {
    const $in = $('#cm-match-mem');
    const $ul = $('<ul class="vn-ac-list"></ul>');   // 처음엔 숨는다(sass) — 결과가 오면 show()
    $in.after($ul);
    let timer = null, last = '';

    $in.on('input', function () {
        $in.data('pick', null);
        const kw = $in.val().trim();
        $('#cm-match-clear').toggle($in.val().length > 0);
        clearTimeout(timer);
        if (kw.length < 2) { $ul.hide().empty(); return; }
        timer = setTimeout(() => {
            if (kw === last) return;
            last = kw;
            $.getJSON('/adm/ajax/devil/call/member-search', {kwd: kw}, rows => {
                if (!rows || !rows.length) { $ul.html('<li class="vn-s21">회원 없음</li>').show(); return; }
                $ul.empty();
                rows.forEach(r => {
                    $('<li>').html(`#${r.num} ${esc(r.mem_name || '')} <b>${esc(r.mem_phone || '')}</b>`)
                        .addClass('vn-ac-item')
                        .on('mousedown', e => {
                            e.preventDefault();
                            $in.val(`#${r.num} ${r.mem_name || ''} (${r.mem_phone || ''})`)
                               .data('pick', {mb_no: r.num, phone: r.mem_phone, name: r.mem_name});
                            $('#cm-match-clear').show();
                            $ul.hide().empty();
                        })
                        .appendTo($ul);
                });
                $ul.show();
            });
        }, 250);
    });
    $in.on('blur', () => setTimeout(() => $ul.hide(), 150));
}

// ── 해제 ─────────────────────────────────────────────────────
function onClickRelease() {
    const $btn = $(this);
    const vn = String($btn.data('vn'));

    $j.Ui.Dialog.open({
        tone:  'danger',
        title: '매칭 해제',
        html: `가상번호 <b>${esc(vn)}</b> 의 연결을 해제할까요?<br><span class="text-muted small">통신사(다우) 연결도 함께 끊깁니다.</span>`,
        confirm: '해제',
        cancel:  '취소',
    }).then(function (ok) {
        if (!ok) return;
        $btn.prop('disabled', true).html('<i class="fa fa-spinner fa-spin"></i>');
        $.post('/adm/ajax/virtual-number/release', {virtual_number: vn}, function (res) {
            if (res.result) $j.Ui.Toast.show(res.message || '해제되었습니다.', {type: 'success'});
            else $j.Ui.Dialog.open({tone: 'danger', title: res.message || '해제 실패'});
            if (res.result) poolTable.ajax.reload(null, false);
            else $btn.prop('disabled', false).html('<i class="fa fa-unlink"></i> 해제');
        }, 'json').fail(() => {
            $j.Ui.Dialog.open({tone: 'danger', title: '서버 오류'});
            $btn.prop('disabled', false).html('<i class="fa fa-unlink"></i> 해제');
        });
    });
}
